import Link from 'next/link'
import Logo from './logo'
import { useTranslations } from 'next-intl'
import { useCookies } from 'next-client-cookies';
import SignupButton from './SignupButton';
import LoginButton from './LoginButton';

export default function Header() {

  const t = useTranslations("Landing")
  const nextCookies = useCookies();
  const token = nextCookies.get("token")

  return (
    <header className="absolute w-full z-30 bg-black dark:bg-transparent">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">

          {/* Site branding */}
          <div className="flex-1">
            <Logo />
          </div>


          {/* Desktop sign in links */}
          <ul className="flex-1 flex justify-end items-center">
            <li hidden={token ? true : false}>
              <LoginButton text={t("loginButton")} />
            </li>
            <li hidden={token ? true : false} className="ml-6">
              <SignupButton text={t("signupButton")} />
            </li>
            <li className="ml-6" hidden={token ? false : true}>
              <a className="btn-sm text-slate-300 hover:text-white transition duration-150 ease-in-out w-full group [background:linear-gradient(theme(colors.slate.900),_theme(colors.slate.900))_padding-box,_conic-gradient(theme(colors.slate.400),_theme(colors.slate.700)_25%,_theme(colors.slate.700)_75%,_theme(colors.slate.400)_100%)_border-box] relative before:absolute before:inset-0 before:bg-slate-800/30 before:rounded-full before:pointer-events-none" href="/app">
                <span className="relative inline-flex items-center">
                {"Dashboard"} <span className="tracking-normal text-purple-500 group-hover:translate-x-0.5 transition-transform duration-150 ease-in-out ml-1">-&gt;</span>
                </span>
              </a>
            </li>
          </ul>


        </div>
      </div>
    </header>
  )
}
